import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconButtons", "i18nKey", "tooltipPlacement", "children"];
import I18n from 'I18n';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderIconButtons = (iconButtons, i18nKey, tooltipPlacement, includeTrailingDivider = false) => {
  const handleMouseDown = evt => {
    // Prevent default to avoid blurring the editor in FF
    // see https://git.hubteam.com/HubSpot/rich-text-lib/issues/344
    evt.preventDefault();
  };
  return iconButtons.map(({
    iconName,
    onClick
  }, idx) => {
    const wrapperProps = {};
    if (idx < iconButtons.length - 1 || includeTrailingDivider) {
      wrapperProps.className = 'popover-preview__head-node';
    }
    const key = `popover-lite-icon-button-${iconName}`;
    return /*#__PURE__*/_jsx(UIBox, Object.assign({}, wrapperProps, {
      children: /*#__PURE__*/_jsx(UIIconButton, {
        "data-test-id": key,
        use: "transparent",
        placement: tooltipPlacement,
        size: "small",
        tooltip: I18n.text(i18nKey(iconName)),
        onClick: onClick,
        onMouseDown: handleMouseDown,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: iconName
        })
      })
    }), key);
  });
};
function PopoverBodyLiteBase(props) {
  const {
      iconButtons,
      i18nKey,
      tooltipPlacement = 'bottom',
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(UIFlex, Object.assign({}, rest, {
    className: "p-all-1",
    tabIndex: -1,
    children: [renderIconButtons(iconButtons, i18nKey, tooltipPlacement, !!children), children]
  }));
}
PopoverBodyLiteBase.displayName = 'PopoverBodyLiteBase';
export default PopoverBodyLiteBase;